import moment from 'moment'
import { get } from 'lodash'
import { decode } from 'he'
import { constants } from '@adc/ui-core'
import { SPOUSE_ON_CONTRACT_NA } from '../constants'
import { getSpouseOnContractStatus } from './relationships'

export const API_DATE_FORMAT_SHORT = 'YYYY-MM-DD'

export const formatDateApiToUi = (
  value,
  inputFormat = API_DATE_FORMAT_SHORT
) => {
  if (!value) return value
  const date = moment(value, inputFormat)
  return date.isValid() ? date.format(constants.statics.UI_DATE_FORMAT) : value
}

export const formatDateUiToApiShort = (
  value,
  displayFormat = API_DATE_FORMAT_SHORT
) => {
  if (!value) return value
  const date = moment(value, constants.statics.UI_DATE_FORMAT)
  return date.isValid() ? date.format(displayFormat) : value
}

export const cobuyerFEtoAPI = (feCobuyers, offerData = []) => {
  return feCobuyers.map((currentBuyer, i) => {
    const cobuyer = offerData[i] || {}
    const spouseOnContractStatus = getSpouseOnContractStatus(currentBuyer)
    const apiCobuyer = {
      ...cobuyer,
      buyer_party: {
        ...cobuyer.buyer_party,
        first_name: currentBuyer.firstName,
        last_name: currentBuyer.lastName,
        middle_name: currentBuyer.middleName,
        no_middle_name: Boolean(currentBuyer.noMiddleName),
        street_name: currentBuyer.streetName,
        city: currentBuyer.city,
        state: currentBuyer.state,
        postal_code: currentBuyer.zipCode,
        phone_number: currentBuyer.phone,
        email_address: currentBuyer.email,
        dob: formatDateUiToApiShort(currentBuyer.dob),
      },
      spouse_on_contract_status: spouseOnContractStatus,
      marital_status: currentBuyer.maritalStatus,
      international_buyer: Boolean(currentBuyer.internationalCheckbox),
      primary_flag: false,
    }
    return apiCobuyer
  })
}

export const cobuyerAPItoFE = (apiCobuyers = []) => {
  return apiCobuyers.map(apiCobuyer => {
    const partyInfo = get(apiCobuyer, 'buyer_party', {})
    const spouseOnContractStatus = getSpouseOnContractStatus(apiCobuyer)

    const feCobuyer = {
      buyerId: apiCobuyer.buyer_id,
      firstName: decode(partyInfo.first_name || ''),
      middleName: decode(partyInfo.middle_name || ''),
      noMiddleName: partyInfo.no_middle_name,
      lastName: decode(partyInfo.last_name || ''),
      streetName: decode(partyInfo.street_name || ''),
      city: decode(partyInfo.city || ''),
      state: partyInfo.state,
      zipCode: partyInfo.postal_code,
      phone: partyInfo.phone_number,
      email: partyInfo.email_address,
      dob: partyInfo.dob ? formatDateApiToUi(partyInfo.dob) : '',
      maritalStatus: apiCobuyer.marital_status,
      internationalCheckbox: apiCobuyer.international_buyer,
      spouseOnContractStatus,
    }
    if (spouseOnContractStatus !== SPOUSE_ON_CONTRACT_NA) {
      feCobuyer.isSpouseOnContract = apiCobuyer.is_spouse_on_contract
      feCobuyer.spouseName = apiCobuyer.spouse_name
      feCobuyer.spouseEmailAddress = apiCobuyer.spouse_email_address
      feCobuyer.spouseMaritalStatus = apiCobuyer.spouse_marital_status
    }
    return feCobuyer
  })
}
